<template>
  <div>
    <a-card :title="pageTitle" style="margin: 20px">
      <template #extra>
        <a-button @click="goBack">返回</a-button>
      </template>

      <!-- 表单区域 -->
      <div class="formBox">
        <a-form-model
            ref="merchantForm"
            :colon="false"
            :label-col="{ span: 4 }"
            :model="formData"
            :rules="formRules"
            :wrapper-col="{ span: 14 }"
            label-align="left"
        >
          <a-form-model-item label="个体户账户" prop="accountNo">
            <WalletChooseDialog
                v-model="formData.accountName"
                :account-class="'0'"
                :open-account-class="true"
                class="short-input"
                @chooseDone="onAccountChosen"
            >
            </WalletChooseDialog>
            <div v-if="formData.accountName" style="margin-top: 8px;">
              <WalletInfo :account-name="formData.accountName" :account-no="formData.accountNo"/>
            </div>
          </a-form-model-item>

          <a-form-model-item label="商户编号" prop="merchantNo">
            <a-input
                v-model.trim="formData.merchantNo"
                :disabled="isEdit"
                allow-clear
                class="short-input"
                placeholder="请输入商户编号"
            />
          </a-form-model-item>

          <a-form-model-item label="商户名称" prop="merchantName">
            <a-input
                v-model.trim="formData.merchantName"
                allow-clear
                class="short-input"
                placeholder="请输入商户名称"
            />
          </a-form-model-item>


          <a-form-model-item label="待清算账户" prop="settleAccountNo">
            <WalletChooseDialog
                v-model="formData.settleAccountName"
                :account-class="'0'"
                :open-account-class="true"
                class="short-input"
                @chooseDone="onSettleAccountChosen"
            >
            </WalletChooseDialog>
            <div v-if="formData.settleAccountName" style="margin-top: 8px;">
              <WalletInfo :account-name="formData.settleAccountName" :account-no="formData.settleAccountNo"/>
            </div>
          </a-form-model-item>


          <a-form-model-item label="税筹默认摘要" prop="taxRemark">
            <a-input
                v-model.trim="formData.taxRemark"
                allow-clear
                class="short-input"
                placeholder="请输入税筹默认摘要"
            />
          </a-form-model-item>

          <a-form-model-item label="服务费收款方">
            <WalletChooseDialog
                v-model="formData.feeAccountName"
                :account-class="'0'"
                :open-account-class="true"
                class="short-input"
                @chooseDone="onFeeAccountChosen"
            >
            </WalletChooseDialog>
            <div v-if="formData.feeAccountName" style="margin-top: 8px;">
              <WalletInfo :account-name="formData.feeAccountName" :account-no="formData.feeAccountNo"/>
            </div>
          </a-form-model-item>

          <a-form-model-item label="服务费规则" prop="feeRuleNo">
            <a-select
                v-model="formData.feeRuleNo"
                allow-clear
                class="short-input"
                placeholder="请选择服务费规则"
                @change="onFeeRuleChange"
            >
              <a-select-option v-for="item in feeRuleList" :key="item.feeNo" :value="item.feeNo">
                {{ item.feeName }}
              </a-select-option>
            </a-select>
          </a-form-model-item>

          <a-form-model-item label="服务费归集摘要">
            <a-input
                v-model.trim="formData.serviceFeeRemark"
                allow-clear
                class="short-input"
                placeholder="请输入服务费归集默认摘要"
            />
          </a-form-model-item>


<!-- 限额区域 -->
          <a-form-model-item label="限额配置">
            <div class="limit-tip">
              <a-icon type="info-circle"/> 三字段联动：
              <b>类型</b>（天/月/季/年）+ <b>时间 n</b>（窗口长度，如 30=30 天/3 月/1 季度/1 年，n=1 表示自然周期）+ <b>额度</b>（元）；任一留空表示不限
              <span class="limit-tip-divider">|</span>
              <span class="limit-tip-example">示例：QUARTER + 1 + 210 = 本季度累计限额 210 元</span>
            </div>
            <a-row :gutter="12" class="limit-row">
              <a-col :span="8">
                <div class="limit-label-inline">
                  <span class="limit-label-text">类型</span>
                  <a-select v-model="formData.periodType" allow-clear placeholder="不限" style="width: 100%">
<a-select-option value="DAY">天 (DAY)</a-select-option>
                  <a-select-option value="MONTH">月 (MONTH)</a-select-option>
                  <a-select-option value="QUARTER">季 (QUARTER)</a-select-option>
                  <a-select-option value="YEAR">年 (YEAR)</a-select-option>
                  </a-select>
                </div>
              </a-col>
              <a-col :span="6">
                <div class="limit-label-inline">
                  <span class="limit-label-text">时间 n</span>
                  <a-input-number
                      v-model="formData.periodValue"
                      :min="1"
                      :step="1"
                      placeholder="n"
                      style="width: 100%"
                  />
                </div>
              </a-col>
              <a-col :span="10">
                <div class="limit-label-inline">
                  <span class="limit-label-text">额度（元）</span>
                  <a-input-number
                      v-model="formData.limitAmount"
                      :min="0"
                      :precision="2"
                      :step="10000"
                      placeholder="不限"
                      style="width: 100%"
                  />
                </div>
              </a-col>
            </a-row>
          </a-form-model-item>

          <!-- 余额支付默认比例 -->
          <a-form-model-item label="余额支付默认比例">
            <div class="limit-tip">
              <a-icon type="info-circle"/> 余额支付下单时按"可用余额 × 比例"自动填充订单金额，用户仍可修改。留空表示不自动填充。
              <span class="limit-tip-divider">|</span>
              <span class="limit-tip-example">示例：80 = 默认填充余额的 80%（100 元余额自动填 80 元）</span>
            </div>
            <input
                :value="formData.balancePayRateInput"
                class="balance-rate-input"
                maxlength="6"
                placeholder="留空=不自动填充（0~100，如 80）"
                type="text"
                @input="e => formData.balancePayRateInput = e.target.value"
            />
            <span style="margin-left: 8px; color: #666;">%</span>
          </a-form-model-item>

          <!-- 分润规则区域 -->
          <a-form-model-item label="服务费分润规则">
            <a-alert
              type="info"
              show-icon
              message="分润金额 = 服务费 × 分润比例；仅设最低金额时直接按最低金额分配；同时设置时取两者较大值。总比例不能超过100%。"
              style="margin-bottom: 12px;"
            />
            <a-table
                :columns="shareRuleColumns"
                :data-source="formData.shareRules"
                :pagination="false"
                :row-key="(record, index) => index"
                bordered
                size="small"
                tableLayout="fixed"
            >
              <template slot="rate" slot-scope="text, record, index">
                <a-input-number
                    v-model="record.rate"
                    :max="100"
                    :min="0"
                    :step="0.01"
                    placeholder="0"
                    style="width: 100%"
                />
              </template>
              <template slot="accountNo" slot-scope="text, record, index">
                <WalletChooseDialog
                    v-model="record.accountName"
                    :account-class="'0'"
                    :open-account-class="true"
                    style="display: inline-block;"
                    @chooseDone="(wallet) => onShareAccountChosen(wallet, index)"
                />
                <div v-if="record.accountNo" style="margin-top: 4px; font-size: 12px; color: #999;">
                  {{ record.accountNo }}
                </div>
              </template>
              <template slot="minShareAmount" slot-scope="text, record, index">
                <a-input-number
                    v-model="record.minShareAmount"
                    :min="0"
                    :precision="2"
                    placeholder="0.00"
                    size="small"
                    style="width: 100%"
                />
              </template>
              <template slot="profitShareRemark" slot-scope="text, record, index">
                <a-input
                    v-model="record.profitShareRemark"
                    placeholder="分润摘要"
                    size="small"
                    style="width: 100%"
                />
              </template>
              <template slot="action" slot-scope="text, record, index">
                <a-button
                    icon="delete"
                    style="color: #ff4d4f;"
                    type="link"
                    @click="removeShareRule(index)"
                >删除
                </a-button>
              </template>
            </a-table>
            <div style="margin-top: 8px;">
              <a-button icon="plus" style="width: 100%;" type="dashed" @click="addShareRule">新增分润规则</a-button>
            </div>
          </a-form-model-item>

          <!-- 按钮区域 -->
          <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
            <a-button @click="goBack">取消</a-button>
            <a-button :loading="confirmLoading" style="margin-left: 8px;" type="primary" @click="handleSave">
              {{ isEdit ? '保存' : '新增' }}
            </a-button>
          </a-form-model-item>
        </a-form-model>
      </div>
    </a-card>
  </div>
</template>

<script>
import {message} from "ant-design-vue";
import WalletChooseDialog from "@/view/components/ChooseDialog/WalletChooseDialog.vue";
import WalletInfo from "@/view/components/WalletInfo.vue";

export default {
  name: 'TaxMerchantConfigDetail',
  components: {WalletInfo, WalletChooseDialog},
  data() {
    return {
      mode: 'add',
formData: {
        id: null,
        merchantNo: '',
        merchantName: '',
        accountNo: '',
        accountName: '',
        settleAccountNo: '',
        settleAccountName: '',
        feeAccountNo: '',
        feeAccountName: '',
        feeRuleNo: '',
        feeRuleName: '',
        serviceFeeRemark: '',
        taxRemark: '',
        clearAgreementNo: '',
        clearAgreementAccountName: '',
        clearAgreementAccountNo: '',
        periodType: undefined,
        periodValue: null,
        limitAmount: null,
        balancePayRateInput: null,
        shareRules: [],
      },
      formRules: {
        merchantNo: [{required: true, message: '请输入商户编号', trigger: 'blur'}],
        merchantName: [{required: true, message: '请输入商户名称', trigger: 'blur'}],
        settleAccountNo: [{required: true, message: '请选择待清算账户', trigger: 'change'}],
        accountNo: [{required: true, message: '请选择个体户账户', trigger: 'change'}],
        taxRemark: [{required: true, message: '请输入税筹默认摘要', trigger: 'blur'}],
      },
      feeRuleList: [],
      shareRuleColumns: [
        {title: '渠道商账号', dataIndex: 'accountNo', width: 160, scopedSlots: {customRender: 'accountNo'}},
        {title: '渠道商名称', dataIndex: 'accountName', align: 'center', width: 100},
        {title: '分润比例(%)', dataIndex: 'rate', width: 100, scopedSlots: {customRender: 'rate'}},
        {title: '最低分润', dataIndex: 'minShareAmount', width: 100, scopedSlots: {customRender: 'minShareAmount'}},
        {title: '分润摘要', dataIndex: 'profitShareRemark', width: 140, scopedSlots: {customRender: 'profitShareRemark'}},
        {title: '操作', key: 'action', width: 80, scopedSlots: {customRender: 'action'}},
      ],
      confirmLoading: false,
    };
  },
  computed: {
    isView() {
      return this.mode === 'view';
    },
    isEdit() {
      return this.mode === 'edit';
    },
    isAdd() {
      return this.mode === 'add';
    },
    pageTitle() {
      const map = {add: '新增商户配置', edit: '编辑商户配置', view: '商户配置详情'};
      return map[this.mode] || '商户配置';
    },
  },
  mounted() {
    this.mode = this.$route.query.mode || 'add';
    if (this.$route.query.id) {
      this.formData.id = this.$route.query.id;
      this.loadDetail();
    }
    this.getFeeRule();
  },
  methods: {
    async loadDetail() {
      try {
        const res = await this.api.getMerchantConfigDetail(this.formData.id);
        if (res.code === 200 && res.data) {
          // 转换分润比例：从小数转为百分比
          if (res.data.shareRules && res.data.shareRules.length > 0) {
            res.data.shareRules = res.data.shareRules.map(rule => ({
              ...rule,
              rate: rule.rate != null ? parseFloat((rule.rate * 100).toFixed(2)) : 0
            }));
          }
          this.formData = {...res.data};
          // 余额支付比例：后端存小数，转成百分比字符串展示（用 a-input 避免 a-input-number 的 blur 重置 bug）
          this.formData.balancePayRateInput = res.data.balancePayRate != null
            ? String(parseFloat((res.data.balancePayRate * 100).toFixed(2)))
            : null;
        } else {
          message.warning(res.info || "获取详情失败");
        }
      } catch (error) {
        console.error("获取详情失败:", error);
        message.error("获取详情失败");
      }
    },

    async getFeeRule() {
      try {
        const res = await this.api.getCommisionFeeRuleApi({});
        if (res.code === 200) {
          this.feeRuleList = res.data.filter(item => item.feeType === '2');
        }
      } catch (error) {
        console.error('加载手续费规则失败:', error);
      }
    },

    onAccountChosen(wallet) {
      this.formData.accountNo = wallet.accountNo;
      this.formData.accountName = wallet.accountName;
      this.formData.merchantName = wallet.accountName;
      this.$nextTick(() => {
        this.$refs.merchantForm && this.$refs.merchantForm.validateField('accountNo');
      });
    },

    onSettleAccountChosen(wallet) {
      this.formData.settleAccountNo = wallet.accountNo;
      this.formData.settleAccountName = wallet.accountName;
      this.$nextTick(() => {
        this.$refs.merchantForm && this.$refs.merchantForm.validateField('settleAccountNo');
      });
    },

    onFeeAccountChosen(wallet) {
      this.formData.feeAccountNo = wallet.accountNo;
      this.formData.feeAccountName = wallet.accountName;
    },

    onFeeRuleChange(value) {
      if (value) {
        const rule = this.feeRuleList.find(r => r.feeNo === value);
        this.formData.feeRuleName = rule ? rule.feeName : '';
      } else {
        this.formData.feeRuleName = '';
      }
    },

    onShareAccountChosen(wallet, index) {
      this.formData.shareRules[index].accountNo = wallet.accountNo;
      this.formData.shareRules[index].accountName = wallet.accountName;
    },

    addShareRule() {
      this.formData.shareRules.push({
        accountNo: '',
        accountName: '',
        rate: '',
        minShareAmount: null,
        profitShareRemark: '',
      });
    },

    removeShareRule(index) {
      this.formData.shareRules.splice(index, 1);
    },

    async handleSave() {
      this.$refs.merchantForm.validate(async (valid) => {
        if (valid) {
          // 校验分润总比例不能超过100%（四舍五入到两位小数避免浮点精度问题）
          const totalRate = Math.round(this.formData.shareRules.reduce((sum, r) => sum + (Number(r.rate) || 0), 0) * 100) / 100;
          if (totalRate > 100) {
            message.warning(`分润总比例为 ${totalRate}%，不能超过 100%`);
            return;
          }
          this.confirmLoading = true;
          try {
            // 转换分润比例：从百分比转为小数；余额支付比例同步转小数，未填写或非法值传 null
            const rateRaw = this.formData.balancePayRateInput;
            const rateInput = rateRaw === null || rateRaw === undefined ? '' : String(rateRaw).trim();
            const balancePayRate = rateInput === ''
              ? null
              : (() => {
                  const num = Number(rateInput);
                  return Number.isFinite(num) ? num / 100 : null;
                })();
            console.log('[handleSave] balancePayRate 提交值:', balancePayRate, '原始输入:', rateInput);
            const submitData = {
              ...this.formData,
              balancePayRate,
              shareRules: this.formData.shareRules.map(rule => ({
                ...rule,
                rate: rule.rate ? rule.rate / 100 : 0
              }))
            };
            let res;
            if (this.isAdd) {
              res = await this.api.addMerchantConfig(submitData);
            } else {
              res = await this.api.updateMerchantConfig(submitData);
            }
            if (res.code === 200) {
              message.success(this.isAdd ? '新增成功' : '保存成功');
              this.$router.push('/tax/merchantConfig');
            } else {
              message.error(res.info || (this.isAdd ? '新增失败' : '保存失败'));
            }
          } catch (error) {
            console.error("保存失败:", error);
            message.error(this.isAdd ? '新增失败' : '保存失败');
          } finally {
            this.confirmLoading = false;
          }
        }
      });
    },

    goBack() {
      this.$router.push('/tax/merchantConfig');
    },
  },
};
</script>

<style lang="less" scoped>
.formBox {
  padding: 20px;
}

.short-input {
  width: 300px !important;
}

/deep/ .ant-form-item {
  margin-bottom: 16px;
}

.limit-label {
  font-size: 12px;
  color: #999;
  margin-bottom: 6px;
}

.limit-tip {
  margin-bottom: 12px;
  padding: 8px 12px;
  font-size: 12px;
  color: #666;
  background: #f5f7fa;
  border-radius: 4px;
  border-left: 3px solid #1890ff;
  line-height: 1.8;
}

.limit-tip-divider {
  color: #ccc;
  margin: 0 8px;
}

.limit-tip-example {
  color: #52c41a;
  font-family: monospace;
}

.limit-row {
  margin-bottom: 8px;
}

.limit-label-inline {
  display: flex;
  align-items: center;
  gap: 8px;
}

.limit-label-text {
  font-size: 13px;
  color: #666;
  white-space: nowrap;
  min-width: 50px;
  font-weight: 500;
}

.balance-rate-input {
  width: 300px;
  height: 32px;
  padding: 4px 11px;
  font-size: 14px;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.85);
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  transition: all 0.3s;
  outline: none;
}
.balance-rate-input:hover {
  border-color: #40a9ff;
}
.balance-rate-input:focus {
  border-color: #40a9ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}
.balance-rate-input::placeholder {
  color: rgba(0, 0, 0, 0.45);
}
</style>